import { catchError, filter, switchMap, take, tap } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/store';

export const UsersGuard = (): Observable<boolean> => {
  const store = inject(Store<fromStore.State>);

  const checkStore = (): Observable<boolean> =>
    store.select(fromStore.getCurrentUserLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          store.dispatch(new fromStore.LoadCurrentUser());
        }
      }),
      filter((loaded) => loaded),
      take(1),
    );

  return checkStore().pipe(
    switchMap(() => of(true)),
    catchError(() => of(false)),
  );
};
